var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"pt-72 md-pt-144 leading-wide min-h-screen flex flex-col"},[_c('header',[_vm._t("header")],2),_c('section',{staticClass:"flex-1 pb-72 md-pb-144"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }